import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/app/[locale]/error.tsx");
